import { documentLocationLines, ClientDocumentSubtotal, ClientDocumentTotals } from 'src/content/applications/quote/ClientDocumentLayout';
import { actualsHistoryPresentation } from './actualsHistoryPresentation';
import { reviewDocumentAdjustment } from 'src/content/applications/quote/documentRevisionReview';
import { sourceCorrectionRows, sourceCorrectionFieldErrors, useActualsSourceCorrections } from './useActualsSourceCorrections';
import { refreshSavedQuoteWorkflow } from 'src/content/applications/quote/refreshSavedQuoteWorkflow';
import ActualsComparisonTableCell from './ActualsComparisonTableCell';
import QuoteEditorSurface from 'src/content/applications/quote/QuoteEditorSurface';
import QuoteEditorTopBar from 'src/content/applications/quote/QuoteEditorTopBar';
import QuoteEditorActionBar from 'src/content/applications/quote/QuoteEditorActionBar';
import EventContractNavigation, { contractPhaseNames } from '../../EventContractNavigation';
import { eventWorkspaceFrameSx } from '../../eventWorkspaceLayout';
import { quoteEventIdentityFromRows } from 'src/content/applications/quote/quoteEventIdentity';
import { groupQuoteRowsInEntryOrder, orderQuoteRows } from 'src/content/applications/quote/quoteShiftOrder';
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import ResponsiveCommunicationTable from 'src/content/applications/quote/ResponsiveCommunicationTable';
import QuoteEditorHeaderActions, { quoteEditorDraftActionSx, quoteEditorApprovalActionSx, quoteEditorDocumentActionSx } from 'src/content/applications/quote/QuoteEditorHeaderActions';
import { useDocumentEditorState } from 'src/content/applications/quote/useDocumentEditorState';
import { comparisonForQuoteRow, isQuoteReference } from 'src/content/applications/quote/updateQuote/clientRequestWorksheetRows';
import { ApprovalArchive, approvedShiftIds } from '../ClientActualsArchive';
import { getActualsApprovalArchive } from 'src/helper/backend_helper';
import { getEventAgreement } from 'src/helper/backend_helper';
import { savedQuoteRateTypes } from 'src/content/applications/quote/updateQuote/savedQuoteRateTypes';
import { DocumentThemeScope } from 'src/content/applications/quote/DocumentThemeScope';
import {actualsAdminNotesText, useDocumentOptions, useDocumentDraftSave, DocumentOptionsEditor, DocumentColgroup, documentTableSx} from 'src/content/applications/quote/clientDocumentOptions';
import { adminActionButtonSx } from 'src/theme/adminActionButton';
import { clientDocumentBranding, ClientDocumentLogo } from 'src/content/applications/quote/clientDocumentBranding';
import AdminModal from 'src/components/AdminModal';
import {
  Menu,
  MenuItem,
  Alert,
  Box,
  Button,
  Card,
  Checkbox,
  Chip,
  CircularProgress,
  Fab,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import Autocomplete from 'react-google-autocomplete';
import { useNavigate, useParams } from 'react-router';
//@ts-ignore
import 'react-toastify/dist/ReactToastify.css';
import {
  approveActuals,
  createActuals,
  createClientInvoiceJobs,
  getActuals,
  getActualsByEventId,
  getAllJobs,
  getAllPositions,
  getAllPositionsCategories,
  getClientInvoiceJobs,
  getQuoteById,
  getAllLastEventHistory
} from 'src/helper/backend_helper';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import {
  compareShifts,
  compareTopLevel,
  ShiftComparison,
  TopLevelChanges
} from 'src/helper/actualComparison';
import AddIcon from '@mui/icons-material/Add';


import { toast } from 'react-toastify';
import { formatDate } from 'src/utils/date';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import ActualsInlineShiftRow from './ActualsInlineShiftRow';

import { useClientDocumentPDF } from 'src/content/applications/quote/useClientDocumentPDF';
import { clientDocumentFilename } from 'src/content/applications/quote/clientDocumentFilename';
import { formatNumber } from 'src/utils/formatters';
import moment from 'moment';
import { Email } from '@mui/icons-material';
import EmailTemplateModal from './emailTemplate';
import Swal from 'sweetalert2';
import { handleApiCall } from 'src/helper/call_api_helper';
import {
  normalizeShiftTotal as normalizePricedShiftTotal,
  quoteTableColumnCount,
  shouldIncludeMiscFees,
  shouldIncludePerDiem
} from '../../../../../../quote/quoteFeeColumns';

const normalizeShiftTotal = (row: any, perDiem: boolean, miscFees: boolean) => row.clientRatePending ? { ...row, rate: null, totals: null, total: null } : normalizePricedShiftTotal(row, perDiem, miscFees);
const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '50%',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: 1
};

const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

type ActualsDeliveryRecovery = {
  id: string;
  fingerprint: string;
  intent: string;
  desiredStatus: string;
  body: string;
  subject: string;
  recipients: string;
  saved: boolean;
  savedFingerprint?: string;
  savedRevision?: string;
  deliveryIntentFingerprint?: string;
  replacesDeliveryAttemptId?: string;
  replacedDeliveryIntentFingerprint?: string;
  allowDuplicateDelivery?: boolean;
};

const createDeliveryAttemptId = () => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `actuals-${Date.now().toString(36)}-${Math.random()
    .toString(36)
    .slice(2)}`;
};

const GenerateActuals = ({ data }: any) => {
  const { id } = useParams();
  const queryClient = useQueryClient();
  const prefetchedDocument = useRef<any>(null);
  const approvalArchiveQuery = useQuery(['actuals-approval-archive', Number(id)],
    () => getActualsApprovalArchive(Number(id)), { enabled: Boolean(id) });
  const archivedApprovals: ApprovalArchive[] = approvalArchiveQuery.data?.data?.data || [];
  const approvedLines = approvedShiftIds(archivedApprovals);
  const rateAgreementQuery = useQuery(['event-agreement', Number(id)], () => getEventAgreement(id), {
    enabled: Boolean(id), select: response => response?.data?.data, retry: false
  });
  const rateTypeOptions = savedQuoteRateTypes(rateAgreementQuery.data);

  const quoteData = data;
  const navigationQuery = useQuery(['qoute', id], () => getQuoteById(id), {
    enabled: Boolean(id), select: response => response?.data?.data, retry: false
  });
  const navigationEvent = navigationQuery.data;
  const [brandingDocument, setBrandingDocument] = useState(quoteData);
  const companyData = clientDocumentBranding(brandingDocument);
  const {options: documentSettings, setOptions: setDocumentSettings} = useDocumentOptions(brandingDocument);
  const navigate = useNavigate();
  const [checked, setChecked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [invoiceEventId, setInvoiceEventId] = useState(0);
  const [selectedDocumentId, setSelectedDocumentId] = useState<number | null>(null);
  const [documentRevisions, setDocumentRevisions] = useState<Array<{ id: number; status: string }>>([]);
  const [positions, setPositions] = useState([]);
  const [includePerDiem, setIncludePerDiem] = useState(true);
  const [includeMiscFees, setIncludeMiscFees] = useState(false);

  console.log('Positions State:', positions);

  const [jobs, setJobs] = useState([]);

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  // const [startDate, setStartDate] = useState<Date | null>(null);
  const [startTime, setStartTime] = useState<Date | null>(null);
  const [endTime, setEndTime] = useState<Date | null>(null);

  const [error, setError] = useState('');
  const [address, setAddress] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');

  const [adminFee, setAdminFee] = useState('');
  const [adminFeeType, setAdminFeeType] = useState('');
  const [adminFeePercentage, setAdminFeePercentage] = useState('');

  const [latitude, setLatitude] = useState(0);
  const [longitude, setLongitude] = useState(0);

  const [loading, setLoading] = useState(false);

  const [removedJobs, setRemovedJobs] = useState([]);
  console.log('Removed Jobs State:', removedJobs);

  // Structure: [{ previousShiftId: currentShiftId, nextShiftId: targetShiftId }]
  const [targetShiftArray, setTargetShiftArray] = useState<
    Array<{ previousShiftId: string | number; nextShiftId: string | number }>
  >([]);
  console.log('Target Shift Array:', targetShiftArray);

  const handlePlaceSelect = (place) => {
    if (!place.geometry || !place.formatted_address) {
      console.error('Invalid place:', place);
      return;
    }

    let locality = '';
    let administrative_area_level_1 = '';

    place.address_components.forEach((component) => {
      if (component.types.includes('locality')) {
        locality = component.long_name;
      } else if (component.types.includes('administrative_area_level_1')) {
        administrative_area_level_1 = component.long_name;
      }
    });

    const location = place.formatted_address;
    const latitude = place.geometry.location.lat();
    const longitude = place.geometry.location.lng();

    setAddress(location);
    setLatitude(latitude);
    setLongitude(longitude);
    setCity(locality);
    setState(administrative_area_level_1);
  };


  const [shiftOpen, setShiftOpen] = React.useState(false);
  const handleOpenShift = () => setShiftOpen(true);
  const handleCloseShift = () => setShiftOpen(false);

  const [selectedShift, setSelectedShift] = useState(null);
  const [editShiftOpen, setEditShiftOpen] = React.useState(false);
  const handleOpenEditShift = () => setEditShiftOpen(true);
  const handleCloseEditShift = () => setEditShiftOpen(false);
  const [editingShiftId, setEditingShiftId] = useState<number | string | null>(
    null
  );
  const [pendingShift, setPendingShift] = useState<any>(null);

  const [venue, setVenue] = useState('');
  const [title, setTitle] = useState('');
  const [billTo, setBillTo] = useState('');
  const [payTo, setPayTo] = useState('');
  const [clientPo, setClientPo] = useState('');
  const [clientEmail, setClientEmail] = useState('');
  const [timezone, setTimezone] = useState('');

  const [emailTemplateBody, setEmailTemplateBody] = useState('');
  console.log('emailTemplateBody', emailTemplateBody);

  const [emailTemplateModalOpen, setEmailTemplateModalOpen] = useState(false);
  // Kept outside render state so a failed transport can retry the same queue
  // identity without writing an unchanged Actuals draft again.
  const deliveryRecoveryRef = useRef<ActualsDeliveryRecovery | null>(null);
  const [savedDeliveryNotice, setSavedDeliveryNotice] = useState('');
  const [deliveryRetryBlocked, setDeliveryRetryBlocked] = useState(false);
  const [duplicateDeliveryWarning, setDuplicateDeliveryWarning] =
    useState(false);

  const [ccEmails, setCcEmails] = useState([]);

  const [date, setDate] = useState(new Date());

  const [requestedNotes, setRequestedNotes] = useState('');
  const [adminNotes, setAdminNotes] = useState('');
  const [status, setStatus] = useState('');
  const [composeStatus, setComposeStatus] = useState('sent');

  // Tracks unsaved changes made after load (used to re-show Approve when approved)
  const [isDirty, setIsDirty] = useState(false);

  // History comparison states
  const [historyLoadMessage, setHistoryLoadMessage] = useState('');
  const [lastEventHistory, setLastEventHistory] = useState<any>(null);
  const [shiftsComparison, setShiftsComparison] = useState<ShiftComparison[]>(
    []
  );
  const [topLevelChanges, setTopLevelChanges] = useState<TopLevelChanges>({});
  const [topLevelIconsHidden, setTopLevelIconsHidden] = useState<
    Record<string, boolean>
  >({});
  console.log('lastEventHistory', lastEventHistory);

  useEffect(() => {
    let active = true;
    const getData = async () => {
      setIsLoading(true);
      const response = prefetchedDocument.current?.data?.data?.id === selectedDocumentId
        ? prefetchedDocument.current : selectedDocumentId ? await getActuals(id, selectedDocumentId) : await getActuals(id);
      prefetchedDocument.current = null;
      if (!active) return;
      setDocumentRevisions(response.data.meta?.revisions || []);
      setBrandingDocument(response.data.data);

      console.log(response.data.data);
      // const response = await getActualsByEventId(id);
      console.log(response);
      setInvoiceEventId(response.data.data?.id);
      setVenue(response.data.data?.venue);
      setTitle(response.data.data?.title);
      setBillTo(response.data.data?.billTo);
      setPayTo(response.data.data?.payTo);
      setClientPo(response.data.data?.clientPo);
      setClientEmail(response.data.data?.clientEmail);
      setCcEmails(
        response.data.data?.ccEmails
          ? response.data.data?.ccEmails.split(',')
          : []
      );
      setTimezone(response.data.data?.timezone);
      setAddress(response.data.data?.address);
      setLatitude(response.data.data?.latitude);
      setLongitude(response.data.data?.longitude);
      setCity(response.data.data?.city);
      setState(response.data.data?.state);
      setChecked(response.data.data?.isAdminFee);
      setRequestedNotes(response.data.data?.requestedNotes);
      setAdminNotes(actualsAdminNotesText(response.data.data?.adminNotes));
      setStatus(response.data.data?.status);
      setDate(response.data.data?.actualSent);

      setAdminFee(response.data.data?.adminFee);
      setAdminFeeType(response.data.data?.adminFeeType);
      setAdminFeePercentage(response.data.data?.adminFeePercentage);
      const nextIncludePerDiem = shouldIncludePerDiem(response.data.data);
      const nextIncludeMiscFees = shouldIncludeMiscFees(response.data.data);
      setIncludePerDiem(nextIncludePerDiem);
      setIncludeMiscFees(nextIncludeMiscFees);

      setPositions(
        response.data.data?.actualsShifts.map((item, index) =>
          normalizeShiftTotal(
            {
              id: item.id,
              shiftId: item.shiftId,
              shiftNumber: item.shiftNumber,
              startDate: item?.startDate,
              endDate: item?.endDate,
              startTime: item.startTime,
              endTime: item.endTime,
              quantity: item?.quantity,
              availableQuantity: item?.availableQuantity ?? 0,
              position: item?.position,
              notes: item?.notes,
              Shift: item?.Shift,
              rateType: item?.rateType,
              rateTypeLabel: item?.rateTypeLabel,
              callType: item?.callType,
              mealBreak: item?.mealBreak,
              rate: Number(item?.rate),
              desiredRate: Number(item?.desiredRate),
              calculatedHours: item?.calculatedHours,
              registerHours: item?.registerHours,
              overTimeHours: item?.overTimeHours,
              DoubleTimeHours: item?.DoubleTimeHours,
              addOns: item?.addOns,
              miscFees: item?.miscFees ?? 0,
              totals: item?.total,
              status: item?.status,
              isLive: true,
              extraQuantity: item?.extraQuantity || 0
            },
            nextIncludePerDiem,
            nextIncludeMiscFees
          )
        )
      );

      setIsLoading(false);
    };
    void getData().catch(error => {
      if (active) {
        setIsLoading(false);
        if (selectedDocumentId) setSelectedDocumentId(null);
        toast.error(error?.response?.data?.message || 'The Actuals document could not be loaded. Open Versions and try again.');
      }
    });
    return () => { active = false; };
  }, [id, selectedDocumentId]);

  const {
    data: positionsArray,

    isLoading: positionsLoading,
    isError
  }: any = useQuery(
    ['positions_categories'], // Unique key for caching
    () => getAllPositionsCategories(), // Fetch function
    {
      keepPreviousData: true // Keeps previous data while fetching new data
    }
  );

  const handleCheckboxChange = () => {
    setChecked(!checked);
    // setChecked(event.target.checked);
  };

  const pendingRowBuffer = useRef<any>(null);
  const [versionsAnchor, setVersionsAnchor] = useState<HTMLElement | null>(null);
  const documentSwitchInFlight = useRef(false);
  const selectCurrentDocument = useRef<(documentId: number) => Promise<boolean>>();
  const currentDocumentId = useRef(invoiceEventId);
  currentDocumentId.current = invoiceEventId;
  const [documentSwitchPending, setDocumentSwitchPending] = useState(false);
  const [savingVersion, setSavingVersion] = useState(false);
  const versionSaveInFlight = useRef(false);
  const documentEditor = useDocumentEditorState('actuals', isLoading ? 0 : invoiceEventId,
    { positions, venue, title, billTo, payTo, clientPo, clientEmail, ccEmails, timezone, address, latitude, longitude, city, state, checked, includePerDiem, includeMiscFees, adminFee, adminFeeType, adminFeePercentage, documentSettings, adminNotes },
    { positions: setPositions, venue: setVenue, title: setTitle, billTo: setBillTo, payTo: setPayTo, clientPo: setClientPo, clientEmail: setClientEmail, ccEmails: setCcEmails, timezone: setTimezone, address: setAddress, latitude: setLatitude, longitude: setLongitude, city: setCity, state: setState, checked: setChecked, includePerDiem: setIncludePerDiem, includeMiscFees: setIncludeMiscFees, adminFee: setAdminFee, adminFeeType: setAdminFeeType, adminFeePercentage: setAdminFeePercentage, documentSettings: setDocumentSettings, adminNotes: setAdminNotes },
    { persistentWorkingCopy: true });
  // Restored drafts already contain these values; discard only the retired dialog buffer.
  useEffect(() => {
    if (documentEditor.headerBuffer) documentEditor.clearHeaderBuffer();
  }, [documentEditor.headerBuffer]);
  const { account: accountDraft, activeRows: privateActivePositions, displayRows: worksheetPositions } = documentEditor;
  useEffect(() => { setPendingShift(null); }, [invoiceEventId, accountDraft.selected]);
  const initializedDraft = useRef({ id: invoiceEventId, ready: false });
  if (initializedDraft.current.id !== invoiceEventId) initializedDraft.current = { id: invoiceEventId, ready: false };
  if (accountDraft.ready) initializedDraft.current.ready = true;
  const canLeaveUnavailableDraft = !initializedDraft.current.ready && accountDraft.status === 'unavailable';
  const optionsSave = useDocumentDraftSave('actuals', { id: invoiceEventId, options: documentSettings,
    canonical: brandingDocument, adminNotes,
    readOnly: status === 'approved' || Boolean(brandingDocument?.actualSent || brandingDocument?.approvedDate), account: accountDraft });
  const saveNewVersion = async () => {
    if (!accountDraft.ready || versionSaveInFlight.current || optionsSave.saving) return;
    versionSaveInFlight.current = true;
    setSavingVersion(true);
    try {
      await accountDraft.saveVersion();
    } finally {
      versionSaveInFlight.current = false;
      setSavingVersion(false);
    }
  };
  const reviewingSource = Boolean(documentEditor.requestKey);
  const sourceReview = useActualsSourceCorrections(isLoading ? 0 : invoiceEventId, reviewingSource, async result => {
    toast.success(result.candidateId ? `Corrections saved in Actuals ${result.candidateId}. Review the new draft before approval.` : 'Review decisions saved.');
    await refreshSavedQuoteWorkflow(queryClient, id);
    await approvalArchiveQuery.refetch();
    if (!result.candidateId) return true;
    prefetchedDocument.current = await getActuals(id, result.candidateId);
    if (currentDocumentId.current !== invoiceEventId) return false;
    return selectCurrentDocument.current(result.candidateId);
  });
  const reviewedPositions = sourceCorrectionRows(sourceReview.context, worksheetPositions).map(row => normalizeShiftTotal(row, includePerDiem, includeMiscFees));
  const activePositions = sourceCorrectionRows(sourceReview.context, privateActivePositions).map(row => normalizeShiftTotal(row, includePerDiem, includeMiscFees));
  const reviewedOutgoingRows = sourceCorrectionRows(sourceReview.context, documentEditor.outgoingRows).map(row => normalizeShiftTotal(row, includePerDiem, includeMiscFees));
  const sourceInputRows = documentEditor.activeRows.map(row => documentEditor.buffer?.id === row.id
    ? reviewDocumentAdjustment(row, { ...row, ...documentEditor.buffer }, comparisonForQuoteRow(row, sourceReview.comparisons || documentEditor.comparisons)) : row);
  const sourceHeader = { review: documentEditor.headerReview, values: { venue, address, latitude, longitude, clientPo, ...documentEditor.headerBuffer } };
  const headerValue = (field: string, value: any, readOnly = false) => {
    if (readOnly) return <Typography variant="h5" color={companyData.primaryTextColor}>{field === 'address' ? documentLocationLines(value || 'N/A') : value || 'N/A'}</Typography>;
    const change = documentEditor.headerReview.changes[field];
    const persisted = sourceReview.context?.meta?.reviewedDecisions?.find(item => item.key === `header:${field}`);
    const decision = documentEditor.headerReview.decisions[field] || persisted?.decision;
    const shown = persisted && (value === change?.base || value === change?.requested) ? persisted.appliedValue : value;
    return <ActualsComparisonTableCell component="div" value={shown || 'N/A'}
      field={field}
      originalValue={change?.base} requestedValue={change?.requested}
      hasChanged={Boolean(change)} decision={decision}
      onDecision={choice => { documentEditor.reviewHeader(field, choice); return true; }}
      formatDisplayValue={display => field === 'address' ? documentLocationLines(display) : display}
      cellSx={{ border: 0, typography: 'h5', color: companyData.primaryTextColor, textAlign: 'left', '& > .MuiStack-root': { justifyContent: 'flex-start' } }} />;
  };
  const selectDocument = async (documentId: number) => {
    if (documentSwitchInFlight.current || documentId === invoiceEventId || isLoading || !accountDraft.ready) return false;
    documentSwitchInFlight.current = true;
    setDocumentSwitchPending(true);
    try {
      void accountDraft.flushWorking();
      setVersionsAnchor(null);
      setEditingShiftId(null);
      setPendingShift(null);
      setIsLoading(true);
      setSelectedDocumentId(documentId);
      return true;
    } finally {
      documentSwitchInFlight.current = false;
      setDocumentSwitchPending(false);
    }
  };

  const navigateFromDocument = (path: string, navigationState?: Record<string, unknown>) => {
    if (documentSwitchInFlight.current || isLoading || sourceReview.busy || savingVersion || optionsSave.saving) return;
    if (!invoiceEventId) { navigate(path, { state: navigationState }); return; }
    if (!accountDraft.ready) {
      if (canLeaveUnavailableDraft) navigate(path, { state: navigationState });
      return;
    }
    void accountDraft.flushWorking();
    navigate(path, { state: navigationState });
  };
  const openContractPhase = (value: string) => {
    if (value === '5') return;
    void navigateFromDocument(`/dashboards/jobTracker/positions/${id}?tab=${contractPhaseNames[value]}`, { tab: value });
  };


  selectCurrentDocument.current = selectDocument;

  // Preview and Send consume the same pending revision; composing never saves it.
  const pendingActuals = React.useMemo(() => {
    const { startDate: startDateEvent, endDate: endDateEvent } =
      quoteEventIdentityFromRows({}, reviewedOutgoingRows);

    return {
      // id: quoteData.id,
      venue,
      title,
      address,
      latitude,
      longitude,
      startDate: startDateEvent,
      endDate: endDateEvent,
      city,
      state,
      billTo,
      payTo,
      clientPo,
      clientEmail,
      isAdminFee: checked,
      adminFeeType,
      adminFeePercentage,
      adminFee,
      includePerDiem,
      includeMiscFees,

      status,
      approvedBy: status === 'approved' ? 'Admin' : '',
      // userId: user?.id,
      timezone,
      documentRowMembership: true,
      shifts: reviewedOutgoingRows.map((item) => {
        return {
          id: typeof item.id === 'string' ? null : item.id,
          eventId: Number(id),
          shiftId: item.shiftId,
          shiftNumber: item.shiftNumber,
          startDate: item.startDate?.includes('T')
            ? item.startDate.split('T')[0]
            : item.startDate,
          endDate: item.endDate?.includes('T')
            ? item.endDate.split('T')[0]
            : item.endDate,
          position: item.position,
          quantity: Number(item.quantity),
          availableQuantity: Number(item.availableQuantity ?? 0),
          startTime: item.startTime,
          endTime: item.endTime,
          timezone: item.timezone,
          notes: item.notes,
          rateType: item.rateType,
          callType: item.callType,
          mealBreak: item.mealBreak,
          rate: item.rate ? Number(item.rate) : 0,
          desiredRate: item.desiredRate ? Number(item.desiredRate) : 0,
          calculatedHours: item.calculatedHours
            ? Number(item.calculatedHours)
            : 0,
          registerHours: item.registerHours ? Number(item.registerHours) : 0,
          overTimeHours: item.overTimeHours ? Number(item.overTimeHours) : 0,
          DoubleTimeHours: item.DoubleTimeHours
            ? Number(item.DoubleTimeHours)
            : 0,
          addOns: item.addOns ? Number(item.addOns) : 0,
          miscFees: item.miscFees ? Number(item.miscFees) : 0,
          total: item.totals ? item.totals : 0
        };
      })
      // removedJobs,
      // targetShiftArray
    };
  }, [positions, id, venue, title, address, latitude, longitude, city, state,
    billTo, payTo, clientPo, clientEmail, checked, adminFeeType, adminFeePercentage,
    adminFee, includePerDiem, includeMiscFees, status, timezone, reviewedOutgoingRows]);

  const handelSubmit = async (body, emails, emailTemplateSubject = '', bccEmails: string[] = [], ccEmails: string[] = []) => {
    // const isValid = checkValid();

    const user = JSON.parse(localStorage.getItem('PLS'))?.user;
    const nextClientEmail = Array.isArray(emails) ? emails.join(',') : clientEmail;
    const submitData = {
      ...pendingActuals,
      status: composeStatus,
      clientEmail: nextClientEmail,
      ccEmails: ccEmails.join(','),
      bccEmails,
      emailTemplateBody: body,
      emailTemplateSubject,
      from: user?.email
    };
    const {
      emailTemplateBody: _emailTemplateBody,
      emailTemplateSubject: _emailTemplateSubject,
      from: _from,
      bccEmails: _bccEmails,
      ...persistedDraft
    } = submitData;
    const fingerprint = JSON.stringify({ ...persistedDraft, documentSettings });
    const intent = JSON.stringify({
      from: user?.email || '',
      to: nextClientEmail,
      cc: ccEmails,
      bcc: bccEmails,
      subject: emailTemplateSubject,
      body
    });
    let deliveryRecovery = deliveryRecoveryRef.current;
    if (!deliveryRecovery || deliveryRecovery.fingerprint !== fingerprint) {
      deliveryRecovery = deliveryRecovery?.allowDuplicateDelivery
        ? {
            ...deliveryRecovery,
            fingerprint,
            intent,
            desiredStatus: composeStatus,
            body,
            subject: emailTemplateSubject,
            recipients: nextClientEmail,
            saved: false
          }
        : {
            id: createDeliveryAttemptId(),
            fingerprint,
            intent,
            desiredStatus: composeStatus,
            body,
            subject: emailTemplateSubject,
            recipients: nextClientEmail,
            saved: false
          };
      deliveryRecoveryRef.current = deliveryRecovery;
      setSavedDeliveryNotice('');
      setDeliveryRetryBlocked(false);
      setDuplicateDeliveryWarning(false);
    } else if (deliveryRecovery.intent !== intent) {
      const previousAttemptId = deliveryRecovery.id;
      const previousIntentFingerprint =
        deliveryRecovery.deliveryIntentFingerprint;
      deliveryRecovery = previousIntentFingerprint
        ? {
            ...deliveryRecovery,
            id: createDeliveryAttemptId(),
            intent,
            body,
            subject: emailTemplateSubject,
            recipients: nextClientEmail,
            replacesDeliveryAttemptId: previousAttemptId,
            replacedDeliveryIntentFingerprint: previousIntentFingerprint,
            allowDuplicateDelivery:
              deliveryRecovery.allowDuplicateDelivery === true
          }
        : {
            id: createDeliveryAttemptId(),
            fingerprint,
            intent,
            desiredStatus: composeStatus,
            body,
            subject: emailTemplateSubject,
            recipients: nextClientEmail,
            saved: false
          };
      deliveryRecoveryRef.current = deliveryRecovery;
      setSavedDeliveryNotice('');
      setDeliveryRetryBlocked(false);
      setDuplicateDeliveryWarning(false);
    }
    const deliveryOnly = deliveryRecovery.saved;
    const requestData = {
      ...submitData,
      deliveryOnly,
      deliveryAttemptId: deliveryRecovery.id,
      ...(deliveryRecovery.allowDuplicateDelivery
        ? { allowDuplicateDelivery: true }
        : {}),
      ...(!deliveryOnly && deliveryRecovery.replacesDeliveryAttemptId
        ? {
            replaceDeliveryIntent: true,
            replacesDeliveryAttemptId:
              deliveryRecovery.replacesDeliveryAttemptId,
            expectedDeliveryIntentFingerprint:
              deliveryRecovery.replacedDeliveryIntentFingerprint
          }
        : {}),
      ...(deliveryOnly
        ? {
            savedFingerprint: deliveryRecovery.savedFingerprint,
            savedRevision: deliveryRecovery.savedRevision,
            expectedDeliveryIntentFingerprint:
              deliveryRecovery.replacedDeliveryIntentFingerprint ||
              deliveryRecovery.deliveryIntentFingerprint,
            ...(deliveryRecovery.replacesDeliveryAttemptId
              ? {
                  replaceDeliveryIntent: true,
                  replacesDeliveryAttemptId:
                    deliveryRecovery.replacesDeliveryAttemptId,
                  ...(deliveryRecovery.allowDuplicateDelivery
                    ? { allowDuplicateDelivery: true }
                    : {})
                }
              : {})
          }
        : {})
    };
    // return console.log(submitData);
    setLoading(true);

    const headers = {
      headers: {
        'content-type': 'application/json'
      }
    };
    try {
      if (!deliveryOnly && !await optionsSave.saveOptions()) return false;
      const response = await accountDraft.runOperational(() => createActuals(invoiceEventId, requestData, headers));
      const delivery = response?.data?.meta?.delivery;
      if (delivery === 'failed' || delivery === 'unknown') {
        const message =
          response?.data?.meta?.message ||
          (delivery === 'unknown'
            ? 'Actuals changes were saved, but the email delivery outcome is unknown. Refresh the status before sending again.'
            : 'Actuals changes were saved, but the email was not sent.');
        if (
          response?.data?.meta?.persistence === 'saved' ||
          deliveryOnly
        ) {
          deliveryRecoveryRef.current = {
            ...deliveryRecovery,
            saved: true,
            savedFingerprint: response?.data?.meta?.savedFingerprint,
            savedRevision: response?.data?.meta?.savedRevision,
            deliveryIntentFingerprint:
              response?.data?.meta?.deliveryIntentFingerprint,
            replacesDeliveryAttemptId: undefined,
            replacedDeliveryIntentFingerprint: undefined,
            allowDuplicateDelivery: undefined
          };
          setClientEmail(nextClientEmail);
          setEmailTemplateBody(body);
          setSavedDeliveryNotice(message);
          setDeliveryRetryBlocked(delivery === 'unknown');
          setDuplicateDeliveryWarning(false);
        }
        throw new Error(message);
      }

      deliveryRecoveryRef.current = null;
      setSavedDeliveryNotice('');
      setDeliveryRetryBlocked(false);
      setDuplicateDeliveryWarning(false);
      setClientEmail(nextClientEmail);
      setEmailTemplateBody(body);
      setStatus(response?.data?.data?.status || status);
      setDate(response?.data?.data?.actualSent || null);
      setIsDirty(false);
      setEmailTemplateModalOpen(false);
      toast.success(
        delivery === 'accepted'
          ? 'Actuals email was already accepted for delivery'
          : delivery === 'queued'
          ? 'Actuals saved and email queued'
          : 'Actuals saved and email sent'
      );
      return true;
    } catch (error) {
      const responseData = (error as {
        response?: {
          data?: {
            code?: unknown;
            message?: unknown;
            meta?: Record<string, unknown>;
          };
        };
      })?.response?.data;
      if (
        responseData?.code ===
        'ACTUALS_DELIVERY_RECONCILIATION_REQUIRED'
      ) {
        const message =
          typeof responseData.message === 'string'
            ? responseData.message
            : 'The Actuals email was accepted, but its status is uncertain. Do not resend until an administrator reconciles the delivery.';
        const meta = responseData.meta || {};
        deliveryRecoveryRef.current = {
          ...deliveryRecovery,
          saved: true,
          savedFingerprint:
            (meta.savedFingerprint as string | undefined) ||
            deliveryRecovery.savedFingerprint,
          savedRevision:
            (meta.savedRevision as string | undefined) ||
            deliveryRecovery.savedRevision,
          deliveryIntentFingerprint:
            (meta.deliveryIntentFingerprint as string | undefined) ||
            deliveryRecovery.deliveryIntentFingerprint,
          replacesDeliveryAttemptId: undefined,
          replacedDeliveryIntentFingerprint: undefined,
          allowDuplicateDelivery: undefined
        };
        setClientEmail(nextClientEmail);
        setEmailTemplateBody(body);
        setSavedDeliveryNotice(message);
        setDeliveryRetryBlocked(true);
        setDuplicateDeliveryWarning(false);
      }
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const refreshUncertainDelivery = async () => {
    const recovery = deliveryRecoveryRef.current;
    if (!deliveryRetryBlocked || !recovery) return false;
    setLoading(true);
    try {
      const response = selectedDocumentId ? await getActuals(Number(id), selectedDocumentId) : await getActuals(Number(id));
      const latest = response?.data?.data;
      const marker = latest?.clientDocumentOptions?._actualsEmailDelivery;
      const confirmed =
        latest?.status === recovery.desiredStatus &&
        marker?.status === 'accepted' &&
        marker?.attemptId === recovery.id &&
        marker?.intentFingerprint ===
          recovery.deliveryIntentFingerprint;
      if (confirmed) {
        deliveryRecoveryRef.current = null;
        setDeliveryRetryBlocked(false);
        setSavedDeliveryNotice('');
        setDuplicateDeliveryWarning(false);
        setStatus(latest.status);
        setDate(latest.actualSent);
        setIsDirty(false);
        setEmailTemplateModalOpen(false);
        toast.success('Actuals email delivery status confirmed');
        return true;
      }
      setSavedDeliveryNotice(
        'Delivery is still unconfirmed. This check did not send another email. You can close this window and continue other work, refresh again later, or explicitly start a new delivery that may duplicate the first.'
      );
      return false;
    } catch {
      setSavedDeliveryNotice(
        'Delivery status could not be refreshed. No email was sent by this check. Close this window to continue other work, then try again later.'
      );
      return false;
    } finally {
      setLoading(false);
    }
  };

  const startNewDeliveryAfterUncertainOutcome = () => {
    const recovery = deliveryRecoveryRef.current;
    if (!recovery?.deliveryIntentFingerprint) {
      setSavedDeliveryNotice(
        'A new delivery cannot be prepared from this saved attempt. Close and reload the Actuals before trying again.'
      );
      return;
    }
    deliveryRecoveryRef.current = {
      ...recovery,
      id: createDeliveryAttemptId(),
      replacesDeliveryAttemptId: recovery.id,
      replacedDeliveryIntentFingerprint:
        recovery.deliveryIntentFingerprint,
      allowDuplicateDelivery: true
    };
    setDeliveryRetryBlocked(false);
    setDuplicateDeliveryWarning(true);
    setSavedDeliveryNotice(
      'A new delivery is ready. Sending it may duplicate the email whose outcome is still unknown.'
    );
  };

  const handleSendInvoice = async (status) => {
    if (status === 'approved' && reviewingSource && !sourceReview.resolved) {
      await sourceReview.submit(sourceInputRows, sourceHeader);
      return;
    }
    setComposeStatus(status);

    if (status === 'approved') {
      deliveryRecoveryRef.current = null;
      setSavedDeliveryNotice('');
      setDeliveryRetryBlocked(false);
      setDuplicateDeliveryWarning(false);
      try {
        setLoading(true);
        const user = JSON.parse(localStorage.getItem('PLS'))?.user;

        const { startDate: startDateEvent, endDate: endDateEvent } =
          quoteEventIdentityFromRows({}, reviewedOutgoingRows);

        const submitData = {
          venue,
          title,
          address,
          latitude,
          longitude,
          startDate: startDateEvent,
          endDate: endDateEvent,
          city,
          state,
          billTo,
          payTo,
          clientPo,
          clientEmail,
          isAdminFee: checked,
          adminFeeType,
          adminFeePercentage,
          adminFee,
          includePerDiem,
          includeMiscFees,
          status: 'approved',
          approvedBy: 'Admin',
          timezone,
          emailTemplateBody: '',
          from: user?.email,
          documentRowMembership: true,
      shifts: reviewedOutgoingRows.map((item) => {
            return {
              id: typeof item.id === 'string' ? null : item.id,
              eventId: Number(id),
              shiftId: item.shiftId,
              shiftNumber: item.shiftNumber,
              startDate: item.startDate?.includes('T')
                ? item.startDate.split('T')[0]
                : item.startDate,
              endDate: item.endDate?.includes('T')
                ? item.endDate.split('T')[0]
                : item.endDate,
              position: item.position,
              quantity: Number(item.quantity),
              availableQuantity: Number(item.availableQuantity ?? 0),
              startTime: item.startTime,
              endTime: item.endTime,
              timezone: item.timezone,
              notes: item.notes,
              rateType: item.rateType,
              callType: item.callType,
              mealBreak: item.mealBreak,
              rate: item.rate ? Number(item.rate) : 0,
              desiredRate: item.desiredRate ? Number(item.desiredRate) : 0,
              calculatedHours: item.calculatedHours
                ? Number(item.calculatedHours)
                : 0,
              registerHours: item.registerHours
                ? Number(item.registerHours)
                : 0,
              overTimeHours: item.overTimeHours
                ? Number(item.overTimeHours)
                : 0,
              DoubleTimeHours: item.DoubleTimeHours
                ? Number(item.DoubleTimeHours)
                : 0,
              addOns: item.addOns ? Number(item.addOns) : 0,
              miscFees: item.miscFees ? Number(item.miscFees) : 0,
              total: item.totals ? item.totals : 0
            };
          })
        };

        const headers = {
          headers: {
            'content-type': 'application/json'
          }
        };

        if (!await optionsSave.saveOptions()) {
          setLoading(false);
          return;
        }
        const response = await accountDraft.runOperational(() => createActuals(
          invoiceEventId, submitData, headers
        ));
        console.log('actuals RESPONSE', response);
        const submitData2 = {
          status: 'approved',
          approvedBy: 'Admin',
          requestedNotes: ''
        };
        await accountDraft.runOperational(() => approveActuals(response.data.data.id, submitData2, {}));
        setDate(new Date());
        toast.success('Actuals approved successfully');
        setLoading(false);
        window.location.reload();
      } catch (error: any) {
        setLoading(false);
        toast.error(
          error?.response?.data?.message || 'Failed to approve actuals'
        );
      }
    } else {
      setEmailTemplateModalOpen(true);
    }
  };

  const getEndDate = (
    startDate: string,
    startTime: string,
    endTime: string
  ) => {
    if (!startDate || !startTime || !endTime) return startDate;
    const startM = moment(startTime, 'HH:mm');
    const endM = moment(endTime, 'HH:mm');
    if (endM.isBefore(startM)) {
      return moment(startDate).add(1, 'day').format('YYYY-MM-DD');
    }
    return startDate;
  };

  const handleAddPosition = (newShift) => {
    setPendingShift(null);
    const newId =
      `document-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    const startStr = newShift.startDate || moment().format('YYYY-MM-DD');
    const endStr = getEndDate(
      startStr,
      newShift.startTime || '08:00',
      newShift.endTime || '19:00'
    );

    const shiftToAdd = normalizeShiftTotal(
      {
        ...newShift,
        id: newId,
        isNew: true,
        isLive: false,
        startDate: startStr,
        endDate: endStr,
        startTime: newShift.startTime || '08:00',
        endTime: newShift.endTime || '19:00',
        quantity: newShift.quantity || 1,
        availableQuantity: newShift.quantity || 1,
        rate: newShift.rate || 0,
        desiredRate: newShift.desiredRate || 0,
        registerHours: newShift.registerHours || 0,
        overTimeHours: newShift.overTimeHours || 0,
        DoubleTimeHours: newShift.DoubleTimeHours || 0,
        addOns: newShift.addOns || 0,
        totals: newShift.totals || 0
      },
      includePerDiem,
      includeMiscFees
    );

    setPositions((prev) => [...prev, shiftToAdd]);
    setEditingShiftId(newId);
    setIsDirty(true);
  };

  const handleAddInlineShift = () => {
    if (pendingShift) {
      setEditingShiftId(pendingShift.id);
      return;
    }
    // Preserve edits to an existing row, but never put an unsubmitted new row in the account draft.
    if (documentEditor.buffer) {
      setPositions(previous => previous.map(row => row.id === documentEditor.buffer.id
        ? normalizeShiftTotal({ ...row, ...documentEditor.buffer }, includePerDiem, includeMiscFees) : row));
    }
    documentEditor.clearBuffer();
    const newId =
      `document-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    setPendingShift({
        id: newId,
        shiftNumber: String((positions?.length || 0) + 1),
        startDate: '',
        endDate: '',
        position: '',
        quantity: 1,
        availableQuantity: 0,
        startTime: '08:00',
        endTime: '19:00',
        notes: '',
        rateType: '',
        callType: 'Setup',
        mealBreak: 'N/A',
        desiredRate: 0,
        rate: 0,
        calculatedHours: 10,
        registerHours: 0,
        overTimeHours: 0,
        DoubleTimeHours: 0,
        addOns: 0,
        miscFees: 0,
        totals: 0,
        extraQuantity: 0,
        isNew: true,
        isLive: false
      });
    setEditingShiftId(newId);
  };

  const renderShiftRow = (position: any, pending = false, history: ReturnType<typeof actualsHistoryPresentation> = null) => (
    <ActualsInlineShiftRow rateTypeOptions={rateTypeOptions}
      key={`${history ? accountDraft.history.key : 'active'}:${position.quoteReferenceKey || position.id}`}
      readOnly={Boolean(history)}
      documentOnly
      pdfExclude={pending}
      onDraftChange={history ? undefined : pending ? row => { pendingRowBuffer.current = row; } : documentEditor.onDraftChange}
      restoredDraft={!pending && !history && documentEditor.restoredBuffer?.id === position.id ? documentEditor.restoredBuffer : null}
      position={position}
      isEditing={!history && !isQuoteReference(position) && (editingShiftId === position.id || documentEditor.editingRowId === position.id)}
      onStartEdit={() => {
        if (isQuoteReference(position)) return;
        if (documentEditor.buffer && documentEditor.buffer.id !== position.id) {
          setPositions(previous => previous.map(row => row.id === documentEditor.buffer.id
            ? normalizeShiftTotal({ ...row, ...documentEditor.buffer }, includePerDiem, includeMiscFees) : row));
          documentEditor.clearBuffer();
        }
        setPendingShift(null);
        setEditingShiftId(position.id);
      }}
      allShifts={history?.positions ?? positions}
      positionsArray={positionsArray}
      comparisonData={pending ? undefined : comparisonForQuoteRow(position, history?.shiftsComparison ?? sourceReview.comparisons ?? documentEditor.comparisons)}
      reviewErrors={pending || history ? undefined : sourceCorrectionFieldErrors(sourceReview.context, position.id)}
      onCancel={() => {
        if (pending) setPendingShift(null);
        else {
          documentEditor.clearBuffer();
          if (position.isNew) setPositions(previous => previous.filter(row => row.id !== position.id));
        }
        setEditingShiftId(null);
      }}
      onSave={(values) => {
        documentEditor.clearBuffer();
        documentEditor.activate(position.id);
        setIsDirty(true);
        const saved = normalizeShiftTotal({ ...position, ...values, isNew: false }, includePerDiem, includeMiscFees);
        setPositions(previous => pending
          ? previous.some(row => row.id === position.id) ? previous : [...previous, saved]
          : previous.map(row => row.id === position.id ? saved : row));
        setPendingShift(null);
        setEditingShiftId(null);
      }}
      onDelete={shiftId => pending ? setPendingShift(null) : setPositions(previous => previous.filter(row => row.id !== shiftId))}
      onDuplicate={values => handleAddPosition(values)}
      documentSettings={history?.documentSettings ?? documentSettings}
      includePerDiem={history?.includePerDiem ?? includePerDiem}
      includeMiscFees={history?.includeMiscFees ?? includeMiscFees}
    />
  );

  // Merge selected jobs via API

  const grandTotalWithoutAdminFee = Object.values(activePositions).reduce(
    (acc, { totals }) => acc + totals,
    0
  ) as number;

  const fivePercent = grandTotalWithoutAdminFee * 0.05;

  const adminFeeValue =
    adminFeeType === 'fixed'
      ? Number(adminFee)
      : (grandTotalWithoutAdminFee * Number(adminFeePercentage)) / 100;
  // const adminFeeValue = checked ? fivePercent : 0;

  const grandTotalWithAdminFee = grandTotalWithoutAdminFee + adminFeeValue;

  const formattedGrandTotalWithAdminFee = Number(
    grandTotalWithAdminFee
  ).toFixed(2);

  const groupedData = groupQuoteRowsInEntryOrder(
    orderQuoteRows(reviewedPositions),
    row => isQuoteReference(row) ? 0 : Number(activePositions.find(active => String(active.id) === String(row.id))?.totals) || 0
  );
  const tableColumnCount = quoteTableColumnCount(documentSettings.includePerDiem, documentSettings.includeMiscFees) + Number(documentSettings.includeArea) + Number(documentSettings.includeToolsGear);

  useEffect(() => {
    setPositions((previousPositions) =>
      Array.isArray(previousPositions)
        ? previousPositions.map((position) =>
            normalizeShiftTotal(position, includePerDiem, includeMiscFees)
          )
        : previousPositions
    );
  }, [includePerDiem, includeMiscFees]);

  const historyView = accountDraft.history ? actualsHistoryPresentation(accountDraft.history.snapshot) : null;
  const viewingHistory = Boolean(historyView);
  const { toPDF, targetRef } = useClientDocumentPDF({
    filename: clientDocumentFilename('Actuals', historyView?.title ?? title, historyView ? accountDraft.history.snapshot.name : brandingDocument?.name)
  });
  const [downloading, setDownloading] = useState(false);

  const handleDownload = async () => {
    setDownloading(true);
    await toPDF();
    setDownloading(false);
  };

  return (
    <Box data-testid="event-workspace-scroll-frame" sx={{ ...eventWorkspaceFrameSx('5'), overflowX: 'auto' }}>
      <TabContext value="5">
        <EventContractNavigation value="5" id={id}
          eventName={navigationEvent?.name || brandingDocument?.name}
          eventIdentity={navigationEvent || brandingDocument}
          contractManagers={navigationEvent?.contractManagers?.map((manager: any) => `${manager.user?.firstName || ''} ${manager.user?.lastName || ''}`.trim()).filter(Boolean)}
          disabled={isLoading || sourceReview.busy || savingVersion || optionsSave.saving || documentSwitchPending || (invoiceEventId > 0 && !accountDraft.ready && !canLeaveUnavailableDraft)}
          onBack={() => void navigateFromDocument('/dashboards/jobTracker')}
          onChange={(_, value) => openContractPhase(value)}
          onReselect={openContractPhase}
        />
        <TabPanel value="5" sx={{ padding: 0 }}>
          <QuoteEditorSurface lifecycle="saved" fixedDocument>
      <Helmet>
        <title>Dashboard | Update Invoice</title>
      </Helmet>

      {/* <IconButton
        onClick={() =>
          navigate('/dashboards/invoice/versions', {
            state: { id }
          })
        }
        sx={{ position: 'absolute', top: 200, right: 85 }}
        size="small"
      >
        <Tooltip title="Client Invoice Versions" arrow>
          <Archive fontSize="small" />
        </Tooltip>
      </IconButton> */}

      <QuoteEditorTopBar
        status={<><Button size="small" variant="outlined" color="inherit" disabled={sourceReview.busy || savingVersion || optionsSave.saving || documentSwitchPending} onClick={event => setVersionsAnchor(event.currentTarget)}>{viewingHistory ? `${accountDraft.versions.find(version => version.key === accountDraft.history.key)?.label ?? 'Version'} (Read-Only)` : 'Versions ▾'}{accountDraft.historyLoading && <CircularProgress size={12} sx={{ ml: 1 }} />}</Button>
        <Menu anchorEl={versionsAnchor} open={Boolean(versionsAnchor)} onClose={() => setVersionsAnchor(null)}>
          {documentRevisions.map(document => <MenuItem key={`document:${document.id}`} selected={invoiceEventId === document.id}
            disabled={sourceReview.busy || isLoading || !accountDraft.ready || documentSwitchPending} onClick={() => void selectDocument(document.id)}>
            Actuals {document.id} - {document.status ? document.status[0].toUpperCase() + document.status.slice(1) : 'Generated'}
          </MenuItem>)}
          <MenuItem selected={!viewingHistory} onClick={() => {
            setVersionsAnchor(null);
            documentEditor.resumeEditing();
            if (pendingShift && pendingRowBuffer.current?.id === pendingShift.id) setPendingShift(pendingRowBuffer.current);
            accountDraft.returnToActive();
          }}>Active Draft</MenuItem>
          {accountDraft.versions.map(version => <MenuItem key={version.key} selected={accountDraft.history?.key === version.key}
            disabled={sourceReview.busy || documentSwitchPending}
            onClick={() => { setVersionsAnchor(null); void accountDraft.viewVersion(version.key); }}>{version.label}</MenuItem>)}
          {!accountDraft.versions.length && <MenuItem disabled>Loading Versions…</MenuItem>}
        </Menu></>}
        exit={viewingHistory ? null : <Button size="small" variant="outlined" color="inherit" disabled={!accountDraft.ready || savingVersion || optionsSave.saving || documentSwitchPending} onClick={() => { setEditingShiftId(null); setPendingShift(null); void accountDraft.restore(accountDraft.selected || 'original'); }}>Discard Changes</Button>}
        save={viewingHistory ? null : <Button size="small" color={accountDraft.hasUnsaved ? "primary" : "inherit"} variant={accountDraft.hasUnsaved ? "contained" : "outlined"} sx={{ ...quoteEditorDraftActionSx, ...(accountDraft.hasUnsaved ? adminActionButtonSx : {}) }} disabled={!accountDraft.ready || savingVersion || optionsSave.saving} onClick={() => void saveNewVersion()}>{savingVersion ? "Saving…" : "Save New Version"}</Button>}
        headerActions={null}
      />
      {accountDraft.historyError && <Typography role="alert" color="error" sx={{ mx: 6 }}>{accountDraft.historyError}</Typography>}
      {!viewingHistory && activePositions.some(row => row.clientRatePending) && <Typography variant="body2" color="warning.main" sx={{ mx: 6, mt: 1 }}>Enter a reviewed rate in each TBD row. Continuing retains the saved row in the outgoing document; new unpriced rows stay in revision history.</Typography>}
      {(accountDraft.error || optionsSave.error || sourceReview.error) && <Alert severity="warning" sx={{ mx: 6, mt: 1 }} action={<Button size="small" onClick={() => void (sourceReview.error ? sourceReview.hasSavedResult ? sourceReview.submit(sourceInputRows, sourceHeader) : sourceReview.reload() : optionsSave.error ? optionsSave.saveOptions() : accountDraft.retry())}>Retry</Button>}>{sourceReview.error || optionsSave.error || accountDraft.error}</Alert>}



      {isLoading && <CircularProgress size={15} />}
      {(({ venue, title, address, billTo, payTo, clientPo, documentSettings, includePerDiem, includeMiscFees, groupedData, tableColumnCount, adminFeeValue, formattedGrandTotalWithAdminFee, adminNotes, requestedNotes, date, status }) => <>
      <DocumentThemeScope className="communication-document client-fixed-document admin-fixed-document" ref={targetRef} document={brandingDocument} refreshSelection {...(!accountDraft.ready ? { inert: '' } : {})}>
        <Stack
          direction={{ md: 'row', sm: 'column' }}
          spacing={{ xs: 1, sm: 3, md: 4 }}
          alignItems="center"
          justifyContent="space-around"
          bgcolor={companyData.primaryColor}
          sx={{
            position: 'relative', // added
            opacity: 0.9,
            mr: 6,
            ml: 6,
            // mt: 2,
            color: '#000',
            '&:hover': {
              color: 'white'
            },
            '&:hover .quote-action-icons': {
              // added
              opacity: 1,
              visibility: 'visible',
              transform: 'translateY(0)'
            }
          }}
          p={2} data-document-header
          data-document-banner
        >
          <QuoteEditorHeaderActions mode="download" documentHeader onEditHeader={() => {}} onDownloadPdf={handleDownload} downloading={downloading} downloadDisabled={downloading || accountDraft.historyLoading} />
          <Stack data-banner-slot="logo">
            <ClientDocumentLogo branding={companyData} height={130} width={130} />
          </Stack>

          <Stack width={200} data-document-company-details data-banner-slot="company">
            <Typography color={companyData.secondaryColor} variant="h4">
              {companyData.name}
            </Typography>
            <Typography variant="h6" color={companyData.primaryTextColor}>
              {companyData.address}
            </Typography>
            <Typography variant="h6" color={companyData.primaryTextColor}>
              {companyData.phone}
            </Typography>
            <Typography variant="h6" color={companyData.primaryTextColor}>
              {companyData.email}
            </Typography>
          </Stack>
          <Stack spacing={1} direction="row" data-document-event-details data-banner-slot="event" data-document-detail-pairs>
            <Stack spacing={1} textAlign="end">
              <Typography color={companyData.secondaryColor} variant="h5">
                Venue:
              </Typography>
              <Typography color={companyData.secondaryColor} variant="h5">
                Pay To:
              </Typography>

              <Typography color={companyData.secondaryColor} variant="h5">
                Job #:
              </Typography>

              <Typography color={companyData.secondaryColor} variant="h5">
                Location:
              </Typography>

              <Typography color={companyData.secondaryColor} variant="h5">
                Bill To:
              </Typography>
              <Typography color={companyData.secondaryColor} variant="h5">
                Client PO:
              </Typography>
            </Stack>
            <Stack spacing={1}>
              {headerValue('venue', venue, viewingHistory)}
              <Typography color={companyData.primaryTextColor} variant="h5">
                {payTo || 'N/A'}
              </Typography>

              <Typography color={companyData.primaryTextColor} variant="h5">
                {title || 'N/A'}
              </Typography>

              {headerValue('address', address, viewingHistory)}

              <Typography color={companyData.primaryTextColor} variant="h5">
                {billTo || 'N/A'}
              </Typography>

              {headerValue('clientPo', clientPo, viewingHistory)}
            </Stack>
          </Stack>

          <Stack data-banner-slot="title">
            <Typography color={companyData.secondaryColor} variant="h1">
              Actuals
            </Typography>
          </Stack>



          {/* <Stack
            direction="row"
            spacing={1}
            className="quote-action-icons"
            sx={{
              position: 'absolute',
              top: 8,
              right: 12,
              color: '#ffffff',
              opacity: 0,
              visibility: 'hidden',
              transform: 'translateY(-6px)',
              transition: 'opacity .25s ease, transform .25s ease',
              '& .MuiSvgIcon-root': {
                cursor: 'pointer',
                fontSize: 26,
                transition: 'color .2s'
              },
              '& .MuiSvgIcon-root:hover': {
                color: companyData.secondaryColor
              }
            }}
          >
            <Email onClick={() => setEmailTemplateModalOpen(true)} />
          </Stack> */}

          <Stack
            direction="column"
            justifyContent="flex-end"
            alignItems="flex-end"
            gap={1}
            sx={{
              position: 'absolute',
              bottom: 8,
              right: 12,
              color: 'white'
            }}
          >
            {date && (
              <Typography
                variant="body2"
                sx={{ fontSize: '14px', fontWeight: 'medium' }}
              >
                Actual Sent: {moment(date).format('MM/DD/YY')}
              </Typography>
            )}
            {status && <Typography
              variant="body2"
              sx={{ fontSize: '14px', fontWeight: 'medium' }}
            >
              Status: {status === 'request' || status === 'requested' ? 'Edited by Client' : status}
            </Typography>}
          </Stack>


        </Stack>

        <ResponsiveCommunicationTable className="client-quote-worksheet client-desktop-table"><TableContainer sx={{ mt: 2, pr: 6, pl: 6 }}>
          <Table sx={documentTableSx(documentSettings)}>
            <DocumentColgroup options={documentSettings}/>
            <TableHead>
              <TableRow sx={{ backgroundColor: companyData.secondaryColor, '& .MuiTableCell-root': { color: companyData.secondaryTextColor } }}>


                <TableCell
                  align="center"
                  sx={{
                    border: `3px solid ${companyData.secondaryColor}`,
                    fontSize: '13px',
                    color: '#000',
                    width: '80px',
                    whiteSpace: 'nowrap'
                  }}
                >
                  Date
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    border: `3px solid ${companyData.secondaryColor}`,
                    fontSize: '13px',
                    color: '#000',
                    width: '50px'
                  }}
                >
                  Qty
                </TableCell>{documentSettings.includeArea && <TableCell align="center">Area/<wbr />Zone</TableCell>}
                <TableCell
                  align="center"
                  sx={{
                    border: `3px solid ${companyData.secondaryColor}`,
                    fontSize: '13px',
                    color: '#000',
                    width: '18%'
                  }}
                >
                  Position
                </TableCell>{documentSettings.includeToolsGear && <TableCell align="center">Tools/<wbr />Gear</TableCell>}
                <TableCell
                  align="center"
                  sx={{
                    border: `3px solid ${companyData.secondaryColor}`,
                    fontSize: '13px',
                    color: '#000',
                    width: '100px'
                  }}
                >
                  Call Time
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    border: `3px solid ${companyData.secondaryColor}`,
                    fontSize: '13px',
                    color: '#000',
                    width: '18%'
                  }}
                >
                  Notes
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    border: `3px solid ${companyData.secondaryColor}`,
                    fontSize: '13px',
                    color: '#000',
                    width: '90px',
                    whiteSpace: 'nowrap'
                  }}
                >
                  Rate Type
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    border: `3px solid ${companyData.secondaryColor}`,
                    fontSize: '13px',
                    color: '#000',
                    width: '90px',
                    whiteSpace: 'nowrap'
                  }}
                >
                  Call Type
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    border: `3px solid ${companyData.secondaryColor}`,
                    fontSize: '13px',
                    color: '#000',
                    width: '100px',
                    whiteSpace: 'nowrap'
                  }}
                >
                  Meal Break
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    border: `3px solid ${companyData.secondaryColor}`,
                    fontSize: '13px',
                    color: '#000',
                    width: '60px',
                    whiteSpace: 'nowrap'
                  }}
                >
                  Rate
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    border: `3px solid ${companyData.secondaryColor}`,
                    fontSize: '13px',
                    color: '#000',
                    width: '60px',
                    whiteSpace: 'nowrap'
                  }}
                >
                  ST Hrs
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    border: `3px solid ${companyData.secondaryColor}`,
                    fontSize: '13px',
                    color: '#000',
                    width: '60px',
                    whiteSpace: 'nowrap'
                  }}
                >
                  OT Hrs
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    border: `3px solid ${companyData.secondaryColor}`,
                    fontSize: '13px',
                    color: '#000',
                    width: '60px',
                    whiteSpace: 'nowrap'
                  }}
                >
                  DT Hrs
                </TableCell>
                {documentSettings.includePerDiem && (
                  <TableCell
                    align="center"
                    sx={{
                      border: `3px solid ${companyData.secondaryColor}`,
                      fontSize: '13px',
                      color: '#000',
                      width: '85px',
                      whiteSpace: 'nowrap'
                    }}
                  >
                    Per Diem
                  </TableCell>
                )}
                {documentSettings.includeMiscFees && (
                  <TableCell
                    align="center"
                    sx={{
                      border: `3px solid ${companyData.secondaryColor}`,
                      fontSize: '13px',
                      color: '#000',
                      width: '85px',
                      whiteSpace: 'nowrap'
                    }}
                  >
                    Misc Fees
                  </TableCell>
                )}
                <TableCell
                  align="center"
                  sx={{
                    border: `3px solid ${companyData.secondaryColor}`,
                    fontSize: '13px',
                    color: '#000',
                    width: '80px',
                    whiteSpace: 'nowrap'
                  }}
                >
                  Totals
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {groupedData.map((data) => {
                  const totalQuantityForDate = data.positions.reduce(
                    (acc, item) => acc + (isQuoteReference(item) ? 0 : Number(item.quantity) || 0),
                    0
                  );

                  return (
                    <>
                      {data?.positions.map(position => renderShiftRow(position, false, historyView))}
                      <ClientDocumentSubtotal branding={companyData} columnCount={tableColumnCount}
                        quantity={totalQuantityForDate} value={`$${formatNumber(data?.total)}`} />
                    </>
                  );
                })}

              {!viewingHistory && pendingShift && renderShiftRow(pendingShift, true)}
              {!viewingHistory && <TableRow data-quote-summary-row="add-shift" data-html2canvas-ignore="true">
                <TableCell colSpan={tableColumnCount}>
                  <Tooltip title="Add Shift" arrow>
                    <Fab
                      size="small"
                      sx={{
                        fontSize: '13px',
                        backgroundColor: companyData.primaryColor,
                        color: companyData.secondaryColor,
                        width: 36,
                        height: 36,
                        cursor: 'pointer',
                        fontWeight: 'bold',
                        textDecoration: 'underline',
                        '&:hover': { backgroundColor: companyData.primaryColor }
                      }}
                      onClick={handleAddInlineShift}
                    >
                      <AddIcon fontSize="small" />
                    </Fab>
                  </Tooltip>
                </TableCell>
              </TableRow>}
            </TableBody>
          </Table>
        </TableContainer>
        <ClientDocumentTotals branding={companyData} rows={[
          ...(adminFeeValue > 0 ? [{ label: 'Admin Fee', value: `$${formatNumber(adminFeeValue)}` }] : []),
          { label: 'Grand Total', value: `$${formatNumber(formattedGrandTotalWithAdminFee)}`, total: true }
        ]} />
        </ResponsiveCommunicationTable>
      </DocumentThemeScope>
      {!viewingHistory && positions.some(line => approvedLines.has(Number(line.shiftId))) && <Typography role="note" sx={{ mx: 6, my: 1, color: 'warning.dark' }}>
        These lines include approved client actuals. Edits change current actuals; archived approvals stay unchanged. Review and resend actuals if needed.
      </Typography>}
      {!viewingHistory && approvalArchiveQuery.isError && <Typography role="alert" sx={{ mx: 6, my: 1, color: 'warning.dark' }}>
        Approval archive unavailable. Approved-line warnings could not be checked.
        <Button onClick={() => approvalArchiveQuery.refetch()}>Retry</Button>
      </Typography>}
      <DocumentOptionsEditor kind="actuals" id={invoiceEventId} options={documentSettings} onChange={setDocumentSettings} disabled={viewingHistory || !accountDraft.ready || status === 'approved' || loading || savingVersion || optionsSave.saving} showVisibilityHint={false} showDocumentNotes={false}/>
      {!viewingHistory && <QuoteEditorActionBar
        lifecycle="saved"
        discard={null}
        save={null}
        adminFee={null}
        terms={null}
        deposit={null}
        approve={<Stack direction="row" spacing={1}>{!loading ? (
              <>
                {/* <Button
                  size="small"
                  variant="outlined"
                  sx={{
                    width: 150,
                    borderColor: '#000000ff',
                    color: '#000000ff',
                    fontWeight: 'bold',
                    '&:hover': {
                      borderColor: '#000000ff',
                      color: '#000000ff',
                      backgroundColor: 'transparent'
                    }
                  }}
                  onClick={() => handelSubmit('')}
                >
                  Update Actuals
                </Button> */}
                {!(status === 'approved' && sourceReview.resolved) && (status !== 'approved' || isDirty || reviewingSource) && (
                  <Button
                    size="small"
                    variant="outlined"
                    sx={quoteEditorApprovalActionSx}
                    disabled={!accountDraft.ready || sourceReview.busy || savingVersion || optionsSave.saving}
                    onClick={() => handleSendInvoice('approved')}
                  >
                    Approve
                  </Button>
                )}

                {/* // positions.length > 0 && ( */}
                {(status !== 'approved' || isDirty) && (
                  <Button
                    size="small"
                    sx={quoteEditorDocumentActionSx}
                    disabled={savingVersion || optionsSave.saving}
                    onClick={() =>
                      handleSendInvoice(
                        status === 'requested' || status === 'request' ? 'resent' : 'sent'
                      )
                    }
                  >
                    Compose
                  </Button>
                )}
              </>
            ) : (
              // )
              <CircularProgress size={20} />
            )}</Stack>}
        compose={null}
      />}
      <Stack data-document-editor-section spacing={2} sx={{ mx: { xs: 2, md: 6 }, mb: 2 }} data-html2canvas-ignore="true">
        {historyLoadMessage && <Typography role="status" sx={{ mb: 1 }}>{historyLoadMessage}</Typography>}
        <TextField
          fullWidth
          multiline
          minRows={3}
          label="Admin Notes"
          size="small"
          value={adminNotes}
          onChange={event => setAdminNotes(event.target.value)}
          disabled={viewingHistory || !accountDraft.ready || savingVersion || optionsSave.saving}
          inputProps={{ maxLength: 20000 }}
        />
        {requestedNotes?.trim() && <TextField
          fullWidth
          id="outlined-multiline-static"
          multiline
          rows={5}
          label="Client Requested Notes"
          placeholder="No client notes provided"
          value={requestedNotes}
          InputProps={{
            readOnly: true
          }}
        />}
      </Stack>

      </>)(historyView ?? { venue, title, address, billTo, payTo, clientPo, documentSettings, includePerDiem, includeMiscFees, groupedData, tableColumnCount, adminFeeValue, formattedGrandTotalWithAdminFee, adminNotes, requestedNotes, date, status })}

      <AdminModal
        open={open}
        onClose={handleClose}
        dialogTitle="Location"
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{ zIndex: 1000 }}
      >
        <Box sx={style}>
          <Stack mb={2}>
            <Autocomplete
              apiKey={process.env.REACT_APP_MAP_API_KEY}
              onPlaceSelected={handlePlaceSelect}
              style={{
                zIndex: 2000,
                padding: 10,
                borderRadius: 10,
                fontSize: 16
              }}
              placeholder="Location"
              options={{
                types: ['geocode', 'establishment']
              }}
              inputAutocompleteValue="country"
            />
          </Stack>

          <Stack>
            {latitude && longitude && (
              <iframe
                width="100%"
                height="400"
                src={`https://maps.google.com/maps?q=${latitude},${longitude}&output=embed`}
                aria-hidden="false"
              />
            )}
            <br />
          </Stack>

          <Stack direction="row" justifyContent="center" gap={1}>
            <Button
              onClick={handleClose}
              variant="contained"
              sx={{
                width: 100,
                ...adminActionButtonSx
              }}
            >
              Submit
            </Button>
            <Button
              variant="outlined"
              sx={{
                width: 100,
                borderColor: companyData.secondaryColor,
                borderWidth: 2,
                color: '#000000',
                '&:hover': {
                  borderColor: companyData.secondaryColor,
                  borderWidth: 2,
                  backgroundColor: 'none'
                }
              }}
              onClick={handleClose}
            >
              Cancel
            </Button>
          </Stack>
        </Box>
      </AdminModal>

      <EmailTemplateModal
        open={emailTemplateModalOpen}
        onClose={() => {
          if (!deliveryRecoveryRef.current?.saved) {
            deliveryRecoveryRef.current = null;
            setSavedDeliveryNotice('');
          }
          setEmailTemplateModalOpen(false);
        }}
        onSave={handelSubmit}
        pendingActuals={pendingActuals}
        savedDeliveryNotice={savedDeliveryNotice}
        deliveryRetryBlocked={deliveryRetryBlocked}
        duplicateDeliveryWarning={duplicateDeliveryWarning}
        savedDeliveryDraft={
          deliveryRecoveryRef.current?.saved
            ? {
                body: deliveryRecoveryRef.current.body,
                subject: deliveryRecoveryRef.current.subject,
                recipients: deliveryRecoveryRef.current.recipients
              }
            : undefined
        }
        onRefreshDeliveryStatus={refreshUncertainDelivery}
        onStartNewDelivery={startNewDeliveryAfterUncertainOutcome}
        emailType="ACTUALS"
        quoteNumber={brandingDocument?.eventId || Number(id)}
        clientName={billTo}
        eventStartDate={brandingDocument?.startDate}
        eventEndDate={brandingDocument?.endDate}
        initialBody={emailTemplateBody}
        address={address}
        venueName={venue}
        eventName={brandingDocument?.name || title}
        companyId={
          brandingDocument?.Event?.companyOwnership?.company?.id ||
          brandingDocument?.companyOwnership?.company?.id ||
          brandingDocument?.companyOwnership?.companyId
        }
        ccEmails={brandingDocument?.ccEmails}
        data={{ clientEmail }}
      />
          </QuoteEditorSurface>
        </TabPanel>
      </TabContext>
    </Box>
  );
};

export default GenerateActuals;
